import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import lowerCase from "lodash/lowerCase";
import isEqual from "lodash/isEqual";
import DropdownSelect from "./DropdownSelect";

const propTypes = {
  works: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.string.isRequired,
  wrapperClass: PropTypes.string,
  theme: PropTypes.oneOf(["default", "subnav", "slideshow"]),
};

const defaultProps = {
  theme: "default",
};

export default class SelectedWorksDropdown extends PureComponent {
  static displayName = "SelectedWorksDropdown";

  static propTypes = propTypes;

  static defaultProps = defaultProps;

  constructor(props) {
    super(props);

    this.state = {
      selectedItem: this.groups.length > 0 ? this.groups[0] : null,
    };
  }

  componentDidMount() {
    if (window.addEventListener) {
      window.addEventListener("message", this.handleSlideMessage, false);
    } else {
      window.attachEvent("onmessage", this.handleSlideMessage);
    }
  }

  componentWillUnmount() {
    if (window.addEventListener) {
      window.removeEventListener("message", this.handleSlideMessage);
    } else {
      window.detatchEvent("onmessage", this.handleSlideMessage);
    }
  }

  get groups() {
    const { works } = this.props;
    let groupId;
    const groups = [];

    if (!works || works.length === 0) return groups;

    works.forEach((item) => {
      if (groupId !== item.group_id) {
        groupId = item.group_id;
        groups.push({
          id: item.group_id,
          name: item.group_name,
          works: works.filter((item) => item.group_id === groupId),
        });
      }
    });

    return groups;
  }

  handleSlideMessage = ({ data, origin }) => {
    if (!data || data[0] !== "slide" || location.origin !== origin) return;

    const { selectedItem } = this.state;
    const id = data[1].groupId;

    if (!id) return;

    if (id !== String(selectedItem?.id)) {
      // get the group
      const group = this.groups.filter((item) => id === String(item.id));
      this.setState({ selectedItem: group[0] });
    }
  };

  filterGroups = (group, inputValue) => {
    if (!inputValue) return true;
    return lowerCase(group.name).includes(lowerCase(inputValue));
  };

  onChange = ({ selectedItem }) => {
    if (!selectedItem || isEqual(selectedItem, this.state.selectedItem)) return;

    this.postGroupMessage(selectedItem);
    this.setState({ selectedItem });
  };

  postGroupMessage(selectedItem) {
    if (typeof window.postMessage !== "undefined") {
      window.postMessage(
        ["group", { workId: selectedItem.works[0].id, id: selectedItem.id }],
        "*"
      );
    }
  }

  renderItem(group, index) {
    const count = group.works.length;

    return (
      <span>
        {group.name}{" "}
        <span className="a-color-light">
          {count} work{count > 1 && "s"}
        </span>
      </span>
    );
  }

  render() {
    const { label, wrapperClass, theme } = this.props;
    const { selectedItem } = this.state;

    if (this.groups.length <= 1) return null;

    return (
      <DropdownSelect
        items={this.groups}
        onChange={this.onChange}
        label={label}
        wrapperClass={wrapperClass}
        theme={theme}
        filterItems={this.filterGroups}
        renderItem={this.renderItem}
        selectedItem={selectedItem}
      />
    );
  }
}
